import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _pt from "prop-types";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import classNames from 'classnames';
import IconAmex from './Amex';
import IconDiscover from './Discover';
import IconMastercard from './Mastercard';
import IconVisa from './Visa';
import "../creditCardIcons.css";
var IconCreditCardLockup = function IconCreditCardLockup(_ref) {
  var id = _ref.id,
    className = _ref.className,
    disableMargins = _ref.disableMargins;
  return /*#__PURE__*/React.createElement("span", {
    id: id,
    className: classNames('lm-IconCreditCardLockup', _defineProperty({}, "lm-IconCreditCard--disable-margin-".concat(disableMargins), disableMargins), className)
  }, /*#__PURE__*/React.createElement(IconVisa, {
    disableMargins: "all"
  }), /*#__PURE__*/React.createElement(IconMastercard, {
    disableMargins: "all"
  }), /*#__PURE__*/React.createElement(IconDiscover, {
    disableMargins: "all"
  }), /*#__PURE__*/React.createElement(IconAmex, {
    disableMargins: "all"
  }));
};
IconCreditCardLockup.propTypes = {
  /** Add an optional ID to this icon. If a label is provided, this ID will appear on the wrapper. */id: _pt.string,
  /** Add custom classes to this element. If a label is provided, this class will appear on the wrapper. */className: _pt.string,
  /** Disable the top, bottom, right or all three margins for spacing purposes. */disableMargins: _pt.oneOf(['all', 'top', 'bottom', 'right'])
};
export default IconCreditCardLockup;